@if (tenantScope.tenant(); as tenant) {
  <div class="band">
    <div class="wrap band-row">
      <span class="band-tag">Branded Storefront</span>
      <span class="band-text">
        You're viewing {{ tenant.name }} - a retailer storefront on the Brijj Finds platform ({{ tenant.subdomain }}.{{
          tenantHost.baseDomain
        }})
      </span>
      @if (tenantScope.marketplaceHomeUrl(); as marketplaceUrl) {
        <!-- Tenant owns this origin: leaving it is a cross-origin trip. -->
        <a class="band-back" [href]="marketplaceUrl">
          <app-icon name="chevron-left" [size]="12" />
          Back to Brijj Finds
        </a>
      } @else {
        <a class="band-back" routerLink="/">
          <app-icon name="chevron-left" [size]="12" />
          Back to Brijj Finds
        </a>
      }
    </div>
  </div>
}
